import { CSSProperties } from "styled-components";

const bannerStyle: CSSProperties = {
  backgroundColor: "#F8D347",
  padding: "5px 10px",
  margin: "0px",
  whiteSpace: "pre",
  width: "100%",
  maxWidth: "100%",
  textWrap: "wrap"
};

const boldStyle: CSSProperties = {
  fontWeight: "bold"
}

const linkStyle: CSSProperties = {
  
}

type AlertProps = {
    Message: string,
    Visible: boolean
};

// split out special elements with -**-{element type}-_-{text}-**-
//  can have 'bold' or 'link' types
//  'link' types add a url like this: -**-link-_-{text}-_-{url}-**-
// ex: "here is text -**-bold-_-this is bold-**- and -**-link-_-this-_-www.google.com-**- is a link to google"
export default function AlertBanner({Message, Visible}: AlertProps) {

  let messageParts: JSX.Element[] = [];
  let splitMessage = Message.split("-**-");
  splitMessage.forEach(function(x, i, a) { 
    if (i % 2 === 1) {
      let special = x.split("-_-");
      switch (special[0]) {
        case ("bold"):
          messageParts.push(<b style={boldStyle}>{special[1]}</b>);
          break;
        case ("link"):
          messageParts.push(<a style={linkStyle} href={special[2]}>{special[1]}</a>);
          break;
      }
    } else if (x.length > 0) {
      messageParts.push(<>{x}</>);
    }
  });

  return Visible ? (
    <p style={bannerStyle}>
      {messageParts.map(x => x)}
    </p>
    ) : <></>
}
